﻿import React, { useState } from "react";
import GoogleButton from "./GoogleButton.jsx";
import { createAccount } from "../utils/accounts.js";

export default function SignupModal({ onSignup, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    setBusy(true);
    try {
      await onSignup(await createAccount({ name, email, password }));
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <form className="modal-card" onSubmit={submit}>
        <h3>Sign Up</h3>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <GoogleButton onSuccess={onSignup} onError={setError} />
        <div className="form-group">
          <label htmlFor="su-name">Name</label>
          <input id="su-name" required autoComplete="name" maxLength={80} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="su-email">Email</label>
          <input id="su-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="su-pw">Password (8+ characters)</label>
          <input id="su-pw" type="password" required minLength={8} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-purple" disabled={busy}>{busy ? "Creating..." : "Create Account"}</button>
        </div>
      </form>
    </div>
  );
}
